import * as React from 'react'
import { IVoteTag, IVote } from 'types'

interface VoteTagProps {
  tag: IVoteTag
  onSelect: (voteTag: IVoteTag) => void
  selected: boolean
}

const VoteTag: React.SFC<VoteTagProps> = ({ tag, onSelect, selected }) => {
  return (
    <div
      onClick={() => onSelect(tag)}
      style={{
        background: 'rgba(255, 255, 255, 0.9)',
        border: '1px solid #BCBCBC',
        boxSizing: 'border-box',
        borderRadius: '5px',
        padding: '10px',
        marginTop: '10px',
        display: 'flex',
      }}
    >
      <input type="checkbox" checked={selected} />
      <div style={{ marginLeft: '10px' }}>{tag.name}</div>
    </div>
  )
}

export default VoteTag



// WEBPACK FOOTER //
// ./src/components/votes/VoteTag.tsx